<template>
  <div class="intro"
    v-text-observe>
    <div class="intro__content">
      <ClaimText
        :canAnimate="isAnimated">
        <slot></slot>
      </ClaimText>
    </div>
  </div>
</template>

<script>
import ClaimText from '@/components/ClaimText/ClaimText.vue'

export default {
  name: 'AnimatedIntro',
  components: {
    ClaimText
  },
  data: () => ({
    isAnimated: false
  }),
  directives: {
    'text-observe': {
      bind (el, binding, vnode) {
        const options = {
          threshold: 0.35
        }
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !vnode.context.isAnimated) {
              vnode.context.isAnimated = true
            }
          })
        }, options)

        observer.observe(el)
      }
    }
  }
}
</script>

<style lang="scss">

@import './style.scss';

</style>
